// Shared UI constants for displaying costs, timings, and rates

export const GAME_TICK_MS = 3000;

// Economy / Build costs
export const FLEET_COST_CREDITS = 100;
export const SHIPYARD_COST_CREDITS = 200;

// Repairs
export const REPAIR_FULL_COST_CREDITS = 50; // Cost to fully repair a fleet from 0 to max
export const REPAIR_MAX_TICKS = 6; // Max ticks for a full repair

// Movement & Combat
// Keep in sync with server/src/game/constants.ts
export const MAP_SCALE = 2; // display/world scale for positions
export const TRAVEL_DISTANCE_PER_TICK = 140; // logical distance units per tick (unchanged by MAP_SCALE)
// Client UI does not calculate combat damage; server uses ship-DPS model


// Economy and population (keep in sync with server constants)
export const ADMIN_BONUS_PER_LEVEL = 0.05;
export const INCOME_RATES = {
  terran: { credits: 0.5, influence: 0.2 },
  desert: { credits: 0.8, influence: 0.1 },
  ice: { credits: 0.3, influence: 0.3 },
  volcanic: { credits: 1.0, influence: 0.05 },
  gas_giant: { credits: 0.4, influence: 0.1 }
} as const;


